import CommonNotificationSettingChange from '../../../common/pages/secure/NotificationSettingChange'

class NotificationSettingChange extends CommonNotificationSettingChange {
  constructor (props) {
    super(props)
    this.userRoleUrl = 'admin'
    this.userRole = 'admin'
  }
}

export default NotificationSettingChange



// WEBPACK FOOTER //
// ./src/admin/pages/secure/NotificationSettingChange.js